import { render, staticRenderFns } from "./ScreenDebugTopicFamily.vue?vue&type=template&id=65463a91&scoped=true&"
import script from "./ScreenDebugTopicFamily.vue?vue&type=script&lang=js&"
export * from "./ScreenDebugTopicFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65463a91",
  null
  
)

export default component.exports